import { WorkScheduleModel } from "../models/worktimeResult";

export function convertUTCDateToLocalDateString(
  utcDateString: string | undefined
): string {
  if (!utcDateString) return "???";
  const utcDate = new Date(utcDateString);
  const localDate = new Date(
    utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
  ); // Convert UTC to local date
  const day = String(localDate.getDate()).padStart(2, "0");
  const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  const year = localDate.getFullYear();
  return `${day}.${month}.${year}`;
}

export function utcToLocal(date: Date): Date {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )
  );
}

// Конвертирование из UTC в локальное время
export function localToUTC(utcDate: Date): Date {
  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds(),
    utcDate.getUTCMilliseconds()
  );
}

// Получение текущего часового пояса в формате: ±N название
export function getCurrentTimezone(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(Math.floor(offsetMinutes / 60));
  const offsetRemainder = Math.abs(offsetMinutes % 60);

  const sign = offsetMinutes <= 0 ? "+" : "-";
  const offsetStr = `${sign}${offsetHours
    .toString()
    .padStart(2, "0")}:${offsetRemainder.toString().padStart(2, "0")}`;

  return `${offsetStr} ${timeZone}`;
}

export function convertWorkScheduleToUTC(schedule: WorkScheduleModel[]): WorkScheduleModel[] {
    return schedule.map(item => {
        return {
            ...item,
            start: convertTimeStringToUTC(item.start),
            end: convertTimeStringToUTC(item.end)
        };
    });
}

export function convertAdminWorkScheduleToUTC(schedule: WorkScheduleModel[]): WorkScheduleModel[] {
    return schedule.map(item => {
        return {
            ...item,
            start: convertAdminTimeStringToUTC(item.start),
            end: convertAdminTimeStringToUTC(item.end)
        };
    });
}

export function convertWorkScheduleToLocal(schedule: WorkScheduleModel[]): WorkScheduleModel[] {
    return schedule.map(item => {
        return {
            ...item,
            start: convertTimeStringToLocal(item.start),
            end: convertTimeStringToLocal(item.end)
        };
    });
}

export function convertAdminTimeStringToUTC(timeString: string): string {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return formatTime(date.getUTCHours(), date.getUTCMinutes());
}

export function convertTimeStringToUTC(timeString: string): string {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setUTCHours(hours, minutes, 0, 0);
    return formatTime(date.getUTCHours(), date.getUTCMinutes());
}

export function convertTimeStringToUTCHint(timeString: string): string {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    const utcDate = localToUTC(date);
    return formatTime(utcDate.getHours(), utcDate.getMinutes());
}

export function convertTimeStringToLocal(timeString: string): string {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setUTCHours(hours, minutes, 0, 0);
    
    return formatTime(date.getHours(), date.getMinutes());
}

function formatTime(hours: number, minutes: number): string {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}